import type { App, Plugin } from 'vue'

// 全局导入 app.use(ZPlus) 组件和插件
export const makeInstaller = (components: Plugin[]) => {
  const install = (app: App) => {
    components.forEach(component => app.use(component))
  }
  return {
    install
  }
}
